// Quarks
import Flex from 'quarks/Flex';
import type { FlexProps } from 'quarks/interpolations/flex';

import ComponentHeading from 'components/Heading/Heading';
import MobileView from 'components/Timeline/MobileView';
import TabletView from 'components/Timeline/TabletView';

// Types
import type { ContentfulComponentTimeline, ContentfulElementTimelineItem } from 'graphqlTypes';
import type { FC } from 'react';

interface TimelineProps extends FlexProps, ContentfulComponentTimeline {
  backgroundIsDark: boolean;
}

export type TimelineItemProps = FlexProps & ContentfulElementTimelineItem;

const ComponentTimeline: FC<TimelineProps> = ({ optionalHeading, backgroundIsDark, ...props }) => (
  <Flex flexDirection="column" gap="32px" md={{ gap: '56px' }}>
    {optionalHeading && (
      <Flex width="100%" maxWidth="100%" lg={{ maxWidth: '670px' }}>
        <ComponentHeading isLeft backgroundIsDark={backgroundIsDark} {...optionalHeading} />
      </Flex>
    )}
    <TabletView {...props} />
    <MobileView {...props} />
  </Flex>
);

export default ComponentTimeline;
